import { useTranslation } from "react-i18next";
import YFSLabelLovableCard from "./YFSLabelLovableCard";
import "./yfs-label-lovable.css";

const YFSLabelCompanyDetail = ({ companyData }) => {
  const { t } = useTranslation();

  if (!companyData) return null;

  return (
    <section id="yfs-label" className="company-ghg-yfs__yfs-section">
      <div className="company-ghg-yfs__yfs-grid">
        <div className="company-ghg-yfs__yfs-copy">
          <h3 className="company-ghg-yfs__yfs-title">YFS Label</h3>
          <p className="company-ghg-yfs__yfs-desc">{t("YFS_label_company_desc")}</p>
          <p className="company-ghg-yfs__yfs-note">
            Three verification levels are indicated: third party, supplier and internal.
          </p>
        </div>

        <div className="company-ghg-yfs__yfs-card-wrap">
          <YFSLabelLovableCard companyData={companyData} />
        </div>
      </div>
    </section>
  );
};

export default YFSLabelCompanyDetail;
